import React from 'react';

import { Card, Typography } from '@mui/material';

import DeparturePackages from './DeparturePackages';
import { aggregateTourPackages } from './packageRows';
import { CommandDeparture, CostBasis } from './types';

export default function TourPackages({ departures, basis }: { departures: CommandDeparture[]; basis: CostBasis }) {
  const packages = aggregateTourPackages(departures);
  if (!packages.some((row) => (row.type === 'ltle' || row.type === 'bundle') && row.pax > 0)) return null;
  return (
    <Card variant="outlined" sx={{ my: 2, p: { xs: 1, md: 2 } }} data-testid="tour-packages">
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Packages Across This Tour
      </Typography>
      <DeparturePackages packages={packages} basis={basis} tour />
    </Card>
  );
}
